const storageKey = 'stale-manifest-reload-at';
const reloadWindowMs = 30_000;

let reloadStarted = false;

const noResultForRouteId = /^No result found for routeId "[^"]+"$/;

const isSingleFetchNoResultError = (error: unknown): error is Error =>
  error instanceof Error && noResultForRouteId.test(error.message);

// A tab from before a deploy still has the old route ids. Single fetch then
// has no result for those ids. Reload once; a repeat inside 30s still reports.
export const shouldReloadStaleRouteManifest = (error: unknown) => {
  if (reloadStarted) return true;
  if (typeof window === 'undefined' || !isSingleFetchNoResultError(error)) {
    return false;
  }

  try {
    const reloadedAt = Number(sessionStorage.getItem(storageKey));
    if (
      Number.isFinite(reloadedAt) &&
      Date.now() - reloadedAt < reloadWindowMs
    ) {
      return false;
    }
  } catch {
    return false;
  }

  reloadStarted = true;
  return true;
};

export const reloadStaleRouteManifest = () => {
  try {
    sessionStorage.setItem(storageKey, String(Date.now()));
  } catch {
    return;
  }

  window.location.reload();
};
